import { whyUs } from '@/mocks/homeData';

export default function WhyUs() {
  return (
    <section className="py-20 md:py-28 bg-[#F7F9FC]">
      <div className="section-container">
        <div className="text-center mb-14 animate-on-scroll">
          <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium mb-5">
            Why Choose Us
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-800 mb-3">
            Why Global Brands<br />Partner With Us
          </h2>
          <p className="text-foreground-500 max-w-[560px] mx-auto leading-relaxed">
            Four pillars that define our commitment to every client relationship and every garment we produce.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {whyUs.map((item, i) => (
            <div
              key={i}
              className={`bg-white rounded-lg p-8 border border-[#E6EAF0] hover:border-primary-200 transition-all duration-300 animate-on-scroll animate-on-scroll-delay-${i + 1}`}
            >
              <div className="w-12 h-12 rounded-lg bg-primary-50 flex items-center justify-center mb-5">
                <i className={`${item.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-800 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}